import { pad0 } from 'utils';
import { DevicePermission } from 'console/device/device_ts';
export const requirements = {
    view_state: [],
    view_gps: [DevicePermission.view_state],
    view_history: [DevicePermission.view_gps],
    control: [DevicePermission.view_state],
    show_configure: [DevicePermission.view_state],
    configure: [DevicePermission.control, DevicePermission.show_configure],
    update_firmware: [DevicePermission.configure],
    ext_configure: [DevicePermission.update_firmware],
};
export const perm_details = new Map([
    [
        DevicePermission.view_state,
        {
            title: 'просмотр текущего состояния',
            description: 'просмотр текущей температуры, режима, местоположения, изображения с камеры',
            short: 'состояние',
        },
    ],
    [
        DevicePermission.view_gps,
        {
            title: 'просмотр маршрутов',
            description: 'просмотр сохранённых данных о перемещениях устройства',
            short: 'маршрут',
        },
    ],
    [
        DevicePermission.view_history,
        {
            title: 'просмотр сохранённых данных',
            description: 'просмотр истории событий, графиков, перемещений и прочих данных, сохранённых устройством',
            short: 'история',
        },
    ],
    [
        DevicePermission.control,
        {
            title: 'управление',
            description: 'управление режимами, состоянием охраны, автозапуском двигателя и прочим',
        },
    ],
    [
        DevicePermission.show_configure,
        {
            title: 'показывать настройки',
            description: 'отображать диалог настроек устройства',
            hide_if_cannot_edit_settings: true,
        },
    ],
    [
        DevicePermission.configure,
        {
            title: 'осуществлять настройку',
            description: 'изменение параметров устройства',
            hide_if_cannot_edit_settings: true,
        },
    ],
    [
        DevicePermission.update_firmware,
        {
            title: 'прошивка',
            description: 'возможность обновить прошивку',
            hide_if_cannot_edit_settings: true,
        },
    ],
    [
        DevicePermission.ext_configure,
        {
            title: 'расширенная настройка',
            description: 'настройка параметров, предназначенных только для сервисных специалистов',
            hide_if_cannot_edit_settings: true,
        },
    ],
]);
const parse_weekschedule = (weekschedule) => {
    //
    // { 2: 0b1101110, 3: 0b1101110, 4: 0b1, 5: 0b1101110 } -> [
    //   { days: [2, 3, 5], hours: [[1, 4], [5, 7]] }
    //   { days: [4], hours: [[0, 1]] }
    // }
    //
    const hour_intervals = {};
    for (let day = 0; day <= 6; day++) {
        const bits = weekschedule[day] ?? 0;
        hour_intervals[day] = [];
        for (let hour = 0; hour <= 24; hour++) {
            if ((bits & (1 << hour)) !== 0 && (bits & (1 << (hour - 1))) === 0)
                hour_intervals[day].push([hour, null]);
            if ((bits & (1 << hour)) === 0 && (bits & (1 << (hour - 1))) !== 0)
                hour_intervals[day][hour_intervals[day].length - 1][1] = hour;
        }
    }
    const hours_str = {};
    for (let day = 0; day <= 6; day++)
        hours_str[day] = JSON.stringify(hour_intervals[day] ?? []);
    const result = [];
    const done = {};
    for (let day = 0; day <= 6; day++) {
        if (done[day])
            continue;
        const days = [];
        for (let another = 0; another <= 6; another++)
            if (hours_str[another] === hours_str[day]) {
                days.push(another);
                done[another] = true;
            }
        if (hour_intervals[day]?.length > 0)
            result.push({
                days,
                hours: (hour_intervals[day] ?? []),
            });
    }
    return result;
};
export function paseWeek(acl) {
    const parsed = parse_weekschedule_by_single_hours_interval(acl?.weekschedule || {});
    return parsed?.length > 0 ? parsed : [];
}
function parse_weekschedule_by_single_hours_interval(weekschedule) {
    const rows = [];
    for (const item of parse_weekschedule(weekschedule))
        for (const hours_interval of item.hours)
            rows.push({ ...item, hours: [hours_interval] });
    return rows;
}
export function unparse_weekschedule(parsed_weekschedule) {
    const weekschedule = {};
    for (const { days, hours } of parsed_weekschedule) {
        for (const day of days) {
            if (weekschedule[day] == null)
                weekschedule[day] = 0;
            for (const hours_pair of hours) {
                const [from, to] = [Math.min(...hours_pair), Math.max(...hours_pair)];
                for (let hour = from; hour < to; hour++)
                    weekschedule[day] |= 1 << hour;
            }
        }
    }
    return weekschedule;
}
export const weekdays = ['пн', 'вт', 'ср', 'чт', 'пт', 'сб', 'вс'];
export function format_weekdays(days) {
    //
    // [1, 2, 3, 5, 6] -> 'вт-чт,сб-вс'
    //
    const parts = [];
    let start = 0;
    while (start <= 6) {
        if (!days.includes(start)) {
            start++;
            continue;
        }
        // for (end = start, asc = start <= 6; asc ? end <= 6 : end >= 6; asc ? end++ : end--) {
        let end;
        for (end = start; end <= 6; end++)
            if (!days.includes(end))
                break;
        if (end === start + 1)
            parts.push(weekdays[start]);
        else if (end > start + 1)
            parts.push(`${weekdays[start]}–${weekdays[end - 1]}`);
        start = end;
    }
    return parts.join(',');
}
//
// { 2: 0b1110, 3: 0b1110, 4: 0b1 } -> [
//   ['ср-чт', '01:00-04:00']
//   ['пт',    '00:00-01:00']
// ]
//
export function format_readable_weekschedule(weekschedule) {
    return parse_weekschedule(weekschedule).map((item) => {
        const hours = item.hours.map((hour_int) => pad0(hour_int[0], 2) + ':00–' + pad0(hour_int[1], 2) + ':00');
        return [format_weekdays(item.days), hours.join(', ')];
    });
}
export function ActiveACLs(access, time) {
    if (!access) {
        return [];
    }
    const nonnull_time = time ?? new Date();
    return access.filter((acl) => !acl.until || acl.until > nonnull_time.getTime() / 1e3);
}
